/**
 * combined-page.js
 *
 * Multi-strategy confluence — a coin is listed on a timeframe when at least
 * 2 different strategies are signalling it in the same direction on that
 * same timeframe. Each card lists the agreeing strategies, plus any other
 * timeframes where the coin also has same-direction signals.
 * Computed server-side in server/combined-signals.js.
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchCombinedData } from '../services/server-api';

const TF_LABELS = { weekly: 'Weekly', daily: 'Daily', fourHour: '4H' };

function renderDetails(entry) {
  const dirClass = entry.state === 'long' ? 'bull' : 'bear';
  return (
    <>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">Strategies ({entry.strategyCount})</span>
        <span className={`mtf-ind-value ${dirClass}`}>{entry.strategies.join(', ')}</span>
      </div>
      {entry.otherTimeframes.map(o => (
        <div className="mtf-ind-row" key={o.timeframe}>
          <span className="mtf-ind-label">Also {TF_LABELS[o.timeframe] || o.timeframe}</span>
          <span className={`mtf-ind-value ${dirClass}`}>{o.strategies.join(', ')}</span>
        </div>
      ))}
    </>
  );
}

function CombinedPage() {
  return (
    <StrategySignalsPage
      config={{
        title:      'Combined',
        icon:       '\u{1F9E9}',
        subtitle:   '2+ strategies signalling the same direction on the same timeframe · other agreeing timeframes listed on each card',
        fetchFn:    fetchCombinedData,
        timeframes: ['weekly', 'daily', 'fourHour'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default CombinedPage;
